module.exports = __webpack_public_path__ + "img/business.d861c9a6.svg";